// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-243a969c] {\n  font-weight: var(--magic-font-weight-semibold, 600);\n  background: var(--magic-primary, #6c5dd3);\n}\n.tag--new[data-v-243a969c] {\n  background: var(--magic-success, #039855);\n}\n.tag--hot[data-v-243a969c] {\n  background: var(--magic-alert, #fd853a);\n}", ""]);
// Exports
module.exports = exports;
